import { configureStore } from "@reduxjs/toolkit";
import infoSlice from "./slices/infoSlice";
import projectSlice from "./slices/projectSlice";
import articlesSlice from "./slices/articlesSlice";
import aboutUsSlice from "./slices/aboutUsSlice";
import productsSlice from "./slices/productsSlice";
import privacyPolicySlice from "./slices/privacyPolicySlice";



export const store = configureStore({
    reducer: {
        info: infoSlice,
        projects: projectSlice,
        articles: articlesSlice,
        aboutUs: aboutUsSlice,
        products: productsSlice,
        privacyPolicy: privacyPolicySlice
    },
    devTools: false

})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch